// extracted by mini-css-extract-plugin
export default {"Skeleton":"Skeleton_Skeleton__T0bfl","loading":"Skeleton_loading__TU8OR"};